import React, { FunctionComponent, ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Constants } from '../../../utils';
import { IRoute } from '../../../interfaces/router.interface';
import { selectIsAuthorized, selectUser } from '../../../redux/authSlice';
import paths from '../../paths';

interface IProps {
  component: ComponentType;
  exact?: boolean;
  public?: boolean;
  childRoutes?: IRoute[];
  childRoutesElements?: JSX.Element[];
  admin?: boolean;
}

const PrivateRoute: FunctionComponent<IProps> = ({
  component: Component,
  admin,
}) => {
  const isAuthorized = useSelector(selectIsAuthorized);
  const user = useSelector(selectUser);
  const location = useLocation();

  if (!user || !isAuthorized) {
    return <Navigate to={paths.signIn} replace />;
  }

  const emailVerified =
    String(user?.email_verified ?? '').toLowerCase() === 'true';

  if (!emailVerified) {
    if (location.pathname === paths.verifyEmail) {
      return (
        <Component>
          <Outlet />
        </Component>
      );
    }

    return <Navigate to={paths.verifyEmail} replace />;
  }

  if (admin && (!user || user['custom:role'] !== Constants.USER_ROLES.admin)) {
    return <Navigate to={paths.signIn} replace />;
  }

  return (
    <Component>
      <Outlet />
    </Component>
  );
};

export default PrivateRoute;
